<template>
  <div>
    <!-- 手机号输入框 -->
    <van-col :span="13" :offset="1" class="m-t-9">
      <van-field
        clearable
        placeholder="请输入手机号"
        class="phone"
        style="height:2.1rem;line-height:1.8rem"
        v-model="phone"
        ref="phone"
      >
        <template #left-icon style="line-height:100%;margin-left:0.3rem">
          <van-icon :name="phoneNew" class="phoneIcon" />
        </template>
      </van-field>
    </van-col>
    <van-col :span="9" :offset="1" class="m-t-10" v-if="loginType != 'forgetPWd'">
      <country-code-selector :countryCode.sync="areaCode"></country-code-selector>
    </van-col>
    <!-- 密码输入框 -->
    <van-col :span="22" :offset="1" class="m-t-9">
      <van-field
        clearable
        placeholder="请输入密码"
        class="phone"
        style="height:2.1rem;line-height:1.8rem"
        v-model="password"
        type="password"
        ref="password"
      >
        <template #left-icon style="line-height:100%;margin-left:0.3rem">
          <van-icon :name="passwordIcon" class="phoneIcon" />
        </template>
      </van-field>
    </van-col>
    <!-- 密码确认框 -->
    <van-col :span="22" :offset="1" class="m-t-9">
      <van-field
        clearable
        placeholder="请再次输入密码"
        class="phone"
        style="height:2.1rem;line-height:1.8rem"
        v-model="newPassword"
        type="password"
        ref="newPassword"
      >
        <template #left-icon style="line-height:100%;margin-left:0.3rem">
          <van-icon :name="passwordIcon" class="phoneIcon" />
        </template>
      </van-field>
    </van-col>
    <!-- 输入验证码  -->
    <van-col :span="13" :offset="1" class="m-t-05">
      <van-field
        clearable
        placeholder="请输入验证码"
        class="phone"
        style="height:2.1rem;line-height:1.8rem"
        v-model="codeNumber"
        ref="codeNumber"
        maxlength="4"
      >
        <template #left-icon style="line-height:100%;margin-left:0.3rem">
          <van-icon :name="passwordIcon" class="passwordIcon" />
        </template>
      </van-field>
    </van-col>
    <van-col :span="9" :offset="1" class="m-t-05">
      <van-button
        type="primary"
        class="b-r-013 f-s-6"
        style="height:2.1rem;width:85%"
        @click="getSms"
        :disabled="this.wait != 60"
        >{{ wait == 60 ? "获取验证码" : "重新发送" + wait }}</van-button
      >
    </van-col>
    <!-- 登录按钮 -->
    <van-col :span="22" :offset="1">
      <van-button
        type="info"
        style="width:100%;margin-top:1rem;height:2.1rem"
        class="f-s-7 b-r-013 xz-button-info"
        @click="updatePwd"
        >确认</van-button
      >
    </van-col>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
import {  codeReg, pwdReg } from "@/utils/regular.js";
import { getVerificationCode, resetPwd } from "@/model/user/userServe";
import Toast from "@/components/toast/tosatInfo";
import countryCodeSelector from "vue-country-code-selector";


export default {
  components: {
    Toast,countryCodeSelector
  },
  data() {
    return {
      phoneNew: require("@/assets/imgs/PhoneNew.png"), // 手机icon
      passwordIcon: require("@/assets/imgs/password.png"), // 密码icon
      phone: "", // 手机号
      password: "", // 新密码
      newPassword: "", // 新密码确认
      wait: 60, // 短信倒计时
      codeNumber: "",
      ifCodeNumber: true,
      areaCode:86
    };
  },
  methods: {
    // 获取短信
    getSms() {
      if (this.areaCode == 86 && this.phone.length != 11) {
        this.$refs.phone.focus(); // 获取输入手机号的焦点
        return false;
      }
      if (this.ifCodeNumber) {
        getVerificationCode({ loginname: this.phone,areaCode:this.areaCode })
          .then((data) => {
            console.log("验证码", data);
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      if (this.wait == 0) {
        this.wait = 60;
        this.ifCodeNumber = true;
      } else {
        this.ifCodeNumber = false;
        this.wait--;
        setTimeout(() => {
          this.getSms();
        }, 1000);
      }
    },
    // 更新密码
    updatePwd() {
      
      if (this.phone.length != 11) {
        this.$refs.phone.focus(); // 获取输入手机号的焦点
        return false;
      }
      if (!pwdReg.test(this.password)) {
        this.$refs.toast.showToast("密码格式不正确");
        this.$refs.password.focus(); // 获取输入验证码的焦点
        return false;
      }
      if (this.password != this.newPassword) {
        this.$refs.toast.showToast("两次输入的密码不一致");
        this.$refs.newPassword.focus(); // 获取输入验证码的焦点
        return false;
      }
      if (!codeReg.test(this.codeNumber)) {
        this.$refs.toast.showToast("请输入正确的验证码");
        this.$refs.codeNumber.focus(); // 获取输入验证码的焦点
        return false;
      }
      let params = {
          loginname: this.phone, //注册手机号
          pwd:this.password, //注册密码
          code:this.codeNumber, //验证码
          areaCode:this.areaCode
        }
        resetPwd(params).then( () =>{
          this.$emit("switchLogin",2)
        }).catch(error => {
            this.$refs.toast.showToast(error.message)
        })
    },
  },
};
</script>
<style scoped>
.intl-tel-input-container >>> .flag-list-box {
  background: white;
  left: -65px;
}
</style>
<style lang="less" scoped>
.phone {
  background: #f2f2f2;
  border-radius: 1.3rem;
  .phoneIcon {
    width: 0.8rem !important;
    height: 0.8rem !important;
    margin-left: 0.3rem;
    margin-right: 0.1rem;
    .van-icon__image {
      width: 0.8rem !important;
      height: 0.8rem !important;
    }
  }
}
</style>
